<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-3">Xiaolu Guo</p>
<p class="TTL">A Lover’s Discourse</p>
<p class="Copyright"><span class="CharOverride-3"><img alt="" class="_idGenObjectAttribute-1" src="image/V-1.jpg"/></span></p>
<p class="Copyright"><span class="CharOverride-4">Grove Press</span></p>
<p class="Copyright"><span class="CharOverride-5">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021495412.vue?47b08b48